import React from 'react';
import styles from './MetricCardWithChart.module.css';
import BarsSmallChart, { ChartValuesEntry } from '../../Charts/BarsSmallChart/BarsSmallChart';
import MetricCard, { MetricCardProps } from '../MetricCard/MetricCard';

type MetricCardWithChartProps = Omit<MetricCardProps, 'renderRight'> & { chartValues?: Array<ChartValuesEntry> };

const MetricCardWithChart = ({ chartValues = [], ...props }: MetricCardWithChartProps) => {
    const lastSevenValues = chartValues.slice(-7);
    return (
        <MetricCard
            {...props}
            renderRight={(loading) =>
                !loading ? (
                    <BarsSmallChart
                        className={styles.chartContainer}
                        values={lastSevenValues}
                        format={props.format}
                        color={props.baseColor}
                    />
                ) : null
            }
        />
    );
};

export default MetricCardWithChart;
